import { doc, getDoc } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';
import { getDownloadURL, ref } from 'firebase/storage';

export function createPerfilVentasRepository({ getFirebase }) {
  return {
    async obtenerUrlFotoPerfilPorUid(uidRaw) {
      const uid = String(uidRaw || '').trim();
      if (!/^[A-Za-z0-9_-]{10,128}$/.test(uid)) return '';
      const { storage } = getFirebase();
      try {
        return await getDownloadURL(ref(storage, `usuarios/${uid}/perfil.webp`));
      } catch (_e) {
        return '';
      }
    },

    /**
     * Nombre del vendedor para mostrar en perfil público por UID.
     * Si el visitante no es el dueño, Firestore deniega `usuarios`; se usa la callable `publicResolverNombreVendedorUid`.
     */
    async obtenerNombrePublicoPorUid(uidRaw) {
      const uid = String(uidRaw || '').trim();
      if (!/^[A-Za-z0-9_-]{10,128}$/.test(uid)) return '';
      try {
        const { db } = getFirebase();
        const snap = await getDoc(doc(db, 'usuarios', uid));
        if (snap.exists()) {
          const raw = snap.data() || {};
          const n = String(raw.nombre || raw.nombre_publico || '').trim();
          if (n) return n;
        }
      } catch (_e) {
        /* permission-denied u otro: callable */
      }
      const { fns } = getFirebase();
      if (!fns) return '';
      try {
        const call = httpsCallable(fns, 'publicResolverNombreVendedorUid');
        const res = await call({ vendedorUid: uid });
        const d = res?.data;
        if (d && d.ok === true && String(d.nombre || '').trim()) {
          return String(d.nombre).trim();
        }
      } catch (_e) {
        /* deploy pendiente / emulador sin function */
      }
      return '';
    },
  };
}
